// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  width: 100%;
  height: 5rem;
  background-color: #044599;
  margin-bottom: 10px;
  margin-top: 10px;
  border-radius: 0.25em;
}

header nav {
  height: 100%;
}

header ul {
  height: 100%;
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: left;
}

header li {
  margin: 0 1rem;
}

header a {
  color: white;
  text-decoration: none;
}

header a:hover,
header a:active,
header a.active {
  color: #95bcf0;
  padding-bottom: 0.25rem;
  border-bottom: 4px solid #95bcf0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC","sourcesContent":["header {\n  width: 100%;\n  height: 5rem;\n  background-color: #044599;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  border-radius: 0.25em;\n}\n\nheader nav {\n  height: 100%;\n}\n\nheader ul {\n  height: 100%;\n  list-style: none;\n  display: flex;\n  padding: 0;\n  margin: 0;\n  align-items: center;\n  justify-content: left;\n}\n\nheader li {\n  margin: 0 1rem;\n}\n\nheader a {\n  color: white;\n  text-decoration: none;\n}\n\nheader a:hover,\nheader a:active,\nheader a.active {\n  color: #95bcf0;\n  padding-bottom: 0.25rem;\n  border-bottom: 4px solid #95bcf0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
